import React, { useState } from "react";
import {
	Modal,
	Box,
	Typography,
	TextField,
	Button,
	CircularProgress,
	IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DropDownValue from "../../baseComponents/dropdownvalue";
import { CallerDidUpdateRequest } from "../callerDidConfig";
import Client from "../../../interfaces/client";
import { useSelector } from "react-redux";
import Agency from "../../../interfaces/agency";
import { RootState } from "../../../store/store";
import CallerDID from "../interface/callerDid";

interface UpdateCallerDIDModalProps {
	callerDid: CallerDID;
	open: boolean;
	onClose: () => void;
	onSubmit: (id: string, caller_did_update_request: CallerDidUpdateRequest) => void;
}

const modalStyle = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 500,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
	borderRadius: 2,
};

const UpdateCallerDIDModal: React.FC<UpdateCallerDIDModalProps> = ({ callerDid, open, onClose, onSubmit }) => {
	// Form State
	const [agencyName, setAgencyName] = useState<string | undefined>(callerDid.agency_name);
	const [clientName, setClientName] = useState<string | undefined>(callerDid.client_name);


	const agencies: Agency[] = useSelector((state: RootState) => state.agencies.agencies);
	const clients: Client[] = useSelector((state: RootState) => state.clients.clients);

	const [loading, setLoading] = useState<boolean>(false);

	const handleClose = () => {
		setAgencyName(undefined);
		setClientName(undefined);
		onClose();
	};

	const handleSubmit = () => {
		setLoading(true);
		onSubmit(callerDid.id, {
			agency_name: agencyName && agencyName.length > 0 ? agencyName : undefined,
			client_name: clientName && clientName.length > 0 ? clientName : undefined
		})
		setLoading(false);
	}

	return (
		<Modal open={open} onClose={handleClose}>
			<Box sx={modalStyle}>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
					<Typography variant="h6">Update Caller DID Mapping: {callerDid.caller_did}</Typography>
					<IconButton onClick={handleClose}>
						<CloseIcon />
					</IconButton>
				</Box>

				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

					<DropDownValue
						label="Select Agency"
						items={agencies}
						selectedValue={agencyName}
						onSelection={(e: string) => setAgencyName(e)}
						keyProp="agency_name"
						valueProp="agency_name"
						displayProp="agency_name"
					/>

					<DropDownValue
						label="Select Client"
						items={clients}
						selectedValue={clientName}
						onSelection={(e: string) => setClientName(e)}
						keyProp="client_name"
						valueProp="client_name"
						displayProp="client_name"
					/>

					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
						<Button onClick={handleClose} sx={{ mr: 2 }}>Cancel</Button>
						<Box mt={2} textAlign="right">
							<Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading}>
								{loading ? <CircularProgress size={24} /> : "Update"}
							</Button>
						</Box>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
};

export default UpdateCallerDIDModal;